export const SIDEBAR_QUERYKEY = "panel";

export const SIDEBAR_VALS = {
  TAGS: "tags",
  SORT: "sort",
  ADD_CARD: "add-card",
  ADD_WOTKFLOW_ITEM: "add-step",
  EDIT_DEFAULT_CARD: "edit-preset",
};
